import React from 'react';
import styled, { css } from 'styled-components';
import Label from './Label';

const StyledCheckboxGroup = styled.div`
  ${({ inline }) =>
    inline &&
    css`
      display: flex;

      ${Label} {
        cursor: pointer;
        margin-right: 16px;
      }
    `}

  input[type='checkbox'] {
    padding: 0;
    margin: 0 8px 0 0;
    cursor: pointer;

    + span {
      margin: 0 24px 0 0;
    }

    &:disabled + span {
      opacity: 0.6;
    }
  }
`;

const CheckboxGroup = React.forwardRef(
  (
    {
      disabled = false,
      inline = false,
      options = [],
      labelProperty = 'label',
      valueProperty = 'value',
      ...registerProps
    },
    ref,
  ) => (
    <StyledCheckboxGroup inline={inline}>
      {options.map((option) => (
        <Label key={option[valueProperty]}>
          <input
            disabled={disabled}
            ref={ref}
            type="checkbox"
            value={option[valueProperty]}
            {...registerProps}
          />
          <span>{option[labelProperty]}</span>
        </Label>
      ))}
    </StyledCheckboxGroup>
  ),
);

export default CheckboxGroup;
